import type CelebrationImages from './CelebrationImages';
import * as CelebrationSvgImages from './CelebrationSvgImages';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isDefaultColor } from 'owa-color-utils/lib/colorUtils';
import getIsDarkTheme from 'owa-fabric-theme/lib/selectors/getIsDarkTheme';

/**
 * If the calendar color is default blue, get the tricolor images
 * If the calendar color is any other color, or dark theme, get the monochrome images
 */
export default function populateCelebrationImages(colorScheme: ColorScheme): CelebrationImages {
    if (colorScheme && isDefaultColor(colorScheme) && !getIsDarkTheme()) {
        return getTriColorImages();
    }

    return getMonoChromeImages();
}

/**
 * Return the svg assets to use in calendar peek, reading pane, and quick compose, when the default color blue is set
 */
export const getTriColorImages = () => ({
    cake: CelebrationSvgImages.CAKE_TRICOLOR_SVG,
    task: CelebrationSvgImages.TASK_TRICOLOR_SVG,
    goal: CelebrationSvgImages.GOAL_TRICOLOR_SVG,
    exam: CelebrationSvgImages.EXAM_TRICOLOR_SVG,
    fitness: CelebrationSvgImages.FITNESS_TRICOLOR_SVG,
});

/**
 * Return the svg text to use in calendar peek, reading pane, and quick compose, when there is a non-default theme or calendar/category color set
 */
export const getMonoChromeImages = () => ({
    cake: CelebrationSvgImages.CAKE_MONOCHROME_SVG_TEXT,
    task: CelebrationSvgImages.TASK_MONOCHROME_SVG_TEXT,
    goal: CelebrationSvgImages.GOAL_MONOCHROME_SVG_TEXT,
    exam: CelebrationSvgImages.EXAM_MONOCHROME_SVG_TEXT,
    fitness: CelebrationSvgImages.FITNESS_MONOCHROME_SVG_TEXT,
});
